import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginAdmin, signupAdmin } from './api/AdminApi.js';
import './AdminLogin.css';

const AdminLogin = ({ setAdmin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isSignup, setIsSignup] = useState(false);
    const navigate = useNavigate(); 

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isSignup) {
                const response = await signupAdmin(email, password);
                alert(response.message);
                setIsSignup(false);
            } else {
                const response = await loginAdmin(email, password);
                console.log("✅ Connexion réussie, réponse :", response);
    
                localStorage.setItem('adminToken', response.token);
                setAdmin({ _id: response.userId, email });
    
                navigate('/HomePageAdmin');
            }
        } catch (err) {
            // Gestion spécifique pour le rate limiting
            if (err.response && err.response.status === 429) {
                const message = err.response.data?.message || "Trop de tentatives. Réessaie plus tard.";
                setError(message);
            } else if (err.response && err.response.data?.message) {
                setError(err.response.data.message);
            } else {
                setError(isSignup ? "Échec de l'inscription" : "Échec de connexion");
            }
            console.error("❌ Erreur dans handleSubmit :", err);
        }
    };
    
    return (
        <div className='bodyPageA'>
        <div className="admin-login-container">
            <div className="admin-login-box">
                <h2>{isSignup ? 'Inscription Admin' : 'Login'}</h2>
                {error && <p className="admin-error-message">{error}</p>}
                <form className="admin-login-form" onSubmit={handleSubmit}>


                    <div className='admin-input-group'>
                      
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}  required/>
                    <label htmlFor="admin-email">Email</label>
                    </div>


                    <div className='admin-input-group'>
                        
                         <input type="password" value={password}onChange={(e) => setPassword(e.target.value)}  required/>
                         <label htmlFor="admin-password">Password</label>
                    </div>


                    <button type="submit" className="admin-button">
                        {isSignup ? "S'inscrire" : 'Se connecter'}
                    </button>
                </form>
            </div>
        </div>
        </div>
    );
};

export default AdminLogin;
